export default {
    get: name => import(/* webpackChunkName: "pages/[request]" */ `../views/${name}`)
}
